/*
 * サブシステム名：運送依頼書
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import date from '@/ddv2.library/date'
import html2canvas from 'html2canvas'
import { jsPDF as JSPDF } from 'jspdf'
import filter from '@/rahmen/utils/filters'
import modals from '@/ddv2.library/modals'
import dolly from '@/rahmen/utils/dolly'
import complements from '@/rahmen/complement'
import indexeddb from '@/ddv2.library/indexeddb'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdUnsoShomenInputForm from '@/views_mrc/components/DdUnsoShomenInputForm'
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')

export default {
  name: 'UnsoShomenIraiEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdEditCommonBar,
    DdTransparentButton,
    DdUnsoShomenInputForm
  },
  data: () => ({
    id: 0,
    rec: {},
    tmprec: {},
    modeKengen: 0,
    registerMode: false,
    deleteMode: false,
    copyMode: false,
    printMode: false,
    shiharaiZumiMode: false,
    niukeninManualDisp: true,
    hatsuchiManualDisp: true,
    chakuchiManualDisp: true,
    hinmeiManualDisp: true,
    hatsuchiHmsDisp: true,
    chakuchiHmsDisp: true,
    hatsuchiYoteiHmsDisp: true,
    chakuchiYoteiHmsDisp: true
  }),
  watch: {
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      kihonJohoList: 'DDMasters/mstKihonJoho',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      sharyoList: 'DDMasters/vwCMstSharyo',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      usersEigyosho: 'users/eigyoshoCd',
      currentKaishaCode: 'users/currentKaishaCode',
      helpUseFlg: 'users/helpUseFlg'
    }),
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2 && !this.shiharaiZumiMode && this.id > 0) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2 && this.id > 0) {
        return true
      }
      return false
    },
    isReadOnlyBase () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.printMode) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    this.id = (this.id === '0') ? 0 : this.id
  },
  mounted () {
    this.initialize()
  },
  beforeRouteLeaveByMenu: function (next) {
    const option = {
      nextCallback: next
    }
    this.preventTransition(option)
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec
      }
    },
    fetchData: function () {
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .get(`/api/v1/VwCD2plod0050/Find?id=${this.id}`)
          .then((data) => {
            if (data.payload) {
              this.rec = data.payload
              this.convertToDispType(() => {
                // 基準日設定
                this.baseYmd = filter.dateFormatter(this.rec.hacchuYmd)
                // クローン情報設定
                this.cloneData = dolly.clone(this.getCloneTargetMethod())
              })
            }
          })
        resolve()
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['mstkihonjoho', 'msteigyosho', 'msttorihikisaki', 'vwcmsteigyoshojininlist', 'vwcmstsharyo', 'msthinmei', 'msthacchakuchi', 'msyskubun', 'mstshubetsu'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: function () {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★', kengen.kengenKbn)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (self.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }
            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      this.initializeForRegister(option)
    },
    // ----------------------------------------------------------------------------------------------------
    // 削除ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onDeleteButtonClick: function (e) {
      const self = this
      self.deleteMode = true
      self.tmprec = Object.assign({}, self.rec)
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.convertToDBType()
            self.HttpClient.post('/api/v1/VwCD2plod0050/DeleteHacchuInfo', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            self.rec = self.tmprec
            self.convertToDispType()
            self.deleteMode = false
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    onCopyButtonClick: function (e) {
      const self = this
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        self.Effects.loadStart()
        self.rec.id = -1
        self.rec.tjmId = -1
        self.rec.tjhId = -1
        self.rec.tjkKinId = -1
        self.rec.tjmKinId = -1
        self.rec.tjhKinId = -1
        self.rec.thrKihonId = -1
        self.rec.thrMeisaiId = -1
        self.rec.trJuchuKihonId = -1
        self.id = 0
        self.modeOfEdit = 0
        self.copyMode = true
        self.Effects.loadComplete()
      })
    },
    onNewButtonClick: function (e) {
      const self = this
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        if (ok === false || ok === undefined) { return }
        self.Effects.loadStart()
        self.initBindVariables()
        self.id = 0
        self.modeOfEdit = 0
        self.Effects.loadComplete()
      })
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.shiharaiZumiMode = Boolean(
              self.cloneData.rec.find((t) => {
                return t.shiharaiZumiFlg === true
              })
            )
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.transitionBack(opt)
    },
    // ----------------------------------------------------------------------------------------------------
    // 保存ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            self.copyMode = false
            self.fetchData()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      const f = this.HttpClient.post('/api/v1/VwCD2plod0050/CreateHacchuInfoWithJuchu', this.rec)
      return f
    },
    registerValidate: function () {
      return true
    },
    async exportPDF () {
      // 1) キャプチャ対象の要素
      this.printMode = true
      this.Effects.loadStart()
      const hacchusakiInfo = this.rec.hacchusakiId ? indexeddb.getRecord(this.torihikisakiList, this.rec.hacchusakiId) : null
      const fileName = `運送依頼書_${hacchusakiInfo ? hacchusakiInfo.torihikisakiNm + '様' : ''}_依頼日${this.rec.hacchuYmd}_${this.getTimeStamp()}.pdf`
      const element = this.$refs.printArea
      document.documentElement.style.fontSize = '26px'
      await this.$nextTick()
      // 2) html2canvas でキャプチャ
      const canvas = await html2canvas(element, {
        scale: 1,
        useCORS: true, // クロスオリジン画像がある場合はサーバ設定も必要
        // 画面のスクロール位置をリセットして要素を「フルキャプチャ」
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        // キャプチャ領域を要素のフルサイズに
        width: element.scrollWidth,
        height: element.scrollHeight
        // logging: false
      })

      document.documentElement.style.fontSize = '16px'

      // 3) Data URL に変換
      const imgData = canvas.toDataURL('image/png')

      // 4) jsPDF で A4(mm) ドキュメントを作成
      //    A4 縦: 210×297 mm
      const pdf = new JSPDF('p', 'mm', 'a4')
      const pdfWidth = pdf.internal.pageSize.getWidth() // 210
      const pdfHeight = pdf.internal.pageSize.getHeight() // 297

      // マージンを mm で指定 (例: 10mm)
      const margin = 5
      const usableW = pdfWidth - margin * 2
      const usableH = pdfHeight - margin * 2
      // 5) 画像の縦横比を保って A4 幅にフィットさせる
      let imgWidth = usableW
      let imgHeight = (canvas.height * imgWidth) / canvas.width

      let offsetX = margin
      const offsetY = margin
      // もし imgH が余白込みの高さを超えるようなら、高さ基準で縮小
      if (imgHeight > usableH) {
        const scaleFactor = usableH / imgHeight
        imgHeight *= scaleFactor
        imgWidth *= scaleFactor
        // 横が縮んだから横中央寄せしたい場合は
        offsetX = margin + (usableW - imgWidth) / 2
      }

      // 6) PDF に画像を配置
      pdf.addImage(imgData, 'PNG', offsetX, offsetY, imgWidth, imgHeight)
      pdf.setProperties({
        title: fileName
      })
      // 7) blob を生成して新しいタブで開く
      const blob = pdf.output('blob')
      const blobUrl = URL.createObjectURL(blob)
      const previewWindow = window.open('', '_blank')
      if (previewWindow) {
        previewWindow.document.write(`
          <html>
            <head>
              <title>${fileName}</title>
              <style>
                body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; font-family: sans-serif; }
                .toolbar { position: fixed; top: 0; left: 0; width: 100%; background-color: #333; color: white; padding: 8px 12px; text-align: right; box-sizing: border-box; z-index: 10; }
                /* ボタンのfont-sizeとpaddingを8pxに合うように調整 */
                .download-btn { background-color: #4CAF50; color: white; padding: 4px 8px; text-decoration: none; border-radius: 4px; font-size: 8px; }
                .download-btn:hover { background-color: #45a049; }
                /* ツールバーの高さに合わせてiframeのpadding-topを調整 */
                iframe { border: none; width: 100%; height: 100%; padding-top: 32px; box-sizing: border-box;}
              </style>
            </head>
            <body>
              <div class="toolbar">
                <a class="download-btn" href="${blobUrl}" download="${fileName}">ダウンロード</a>
              </div>
              <iframe src="${blobUrl}" type="application/pdf"></iframe>
            </body>
          </html>
        `)
        previewWindow.document.close()
      } else {
        // ポップアップがブロックされた場合のフォールバック
        console.error('ポップアップがブロックされました。このサイトのポップアップを許可してください。')
        // フォールバックとして直接ダウンロードを実行
        pdf.save(fileName)
      }
      this.printMode = false
      this.Effects.loadComplete()
    },
    // ----------------------------------------------------------------------------------------------------
    // 画面表示用フォーマット変換
    // ----------------------------------------------------------------------------------------------------
    convertToDispType: function () {
      return new Promise(resolve => {
        const p = Object.assign({}, this.rec)
        if (p.hacchuYmd) {
          p.hacchuYmd = filter.dateFormatter(p.hacchuYmd)
        }
        if (p.hacchusakiHikiukeYmd) {
          p.hacchusakiHikiukeYmd = filter.dateFormatter(p.hacchusakiHikiukeYmd)
        } else {
          p.hacchusakiHikiukeYmd = p.hacchuYmd
        }
        if (p.niukeninId > 0 && !p.niukeninBiko) {
          this.niukeninManualDisp = false
        }
        if (p.hatsuchiId > 0 && !p.hatsuchiBiko) {
          this.hatsuchiManualDisp = false
        }
        if (p.chakuchiId > 0 && !p.chakuchiBiko) {
          this.chakuchiManualDisp = false
        }
        if (p.mstHinmeiId > 0 && !p.hinmeiBiko) {
          this.hinmeiManualDisp = false
        }
        if (p.hatsuchiYmd) {
          p.hatsuchiYmd = filter.dateFormatter(p.hatsuchiYmd)
        }
        if (p.hatsuchiHms) {
          p.hatsuchiHms = complements.parseTime(p.hatsuchiHms, false).substr(0, 5)
        } else {
          this.hatsuchiHmsDisp = false
        }
        if (p.chakuchiYmd) {
          p.chakuchiYmd = filter.dateFormatter(p.chakuchiYmd)
        }
        if (p.chakuchiHms) {
          p.chakuchiHms = complements.parseTime(p.chakuchiHms, false).substr(0, 5)
        } else {
          this.chakuchiHmsDisp = false
        }
        if (p.tsumikomiSagyoJikan) {
          p.tsumikomiSagyoJikan = filter.minToIntervalTimeFormatter(p.tsumikomiSagyoJikan)
        }
        if (p.torioroshiSagyoJikan) {
          p.torioroshiSagyoJikan = filter.minToIntervalTimeFormatter(p.torioroshiSagyoJikan)
        }
        if (p.taikiJikan) {
          p.taikiJikan = filter.minToIntervalTimeFormatter(p.taikiJikan)
        }
        if (p.warimashiTaishoJikan) {
          p.warimashiTaishoJikan = filter.minToIntervalTimeFormatter(p.warimashiTaishoJikan)
        }
        if (p.shiharaiYoteiYmd) {
          p.shiharaiYoteiYmd = filter.dateFormatter(p.shiharaiYoteiYmd)
        }
        if (p.hatsuchiYoteiYmd) {
          p.hatsuchiYoteiYmd = filter.dateFormatter(p.hatsuchiYoteiYmd)
        }
        if (p.hatsuchiYoteiHms) {
          p.hatsuchiYoteiHms = complements.parseTime(p.hatsuchiYoteiHms, false).substr(0, 5)
        } else {
          this.hatsuchiYoteiHmsDisp = false
        }
        if (p.chakuchiYoteiYmd) {
          p.chakuchiYoteiYmd = filter.dateFormatter(p.chakuchiYoteiYmd)
        }
        if (p.chakuchiYoteiHms) {
          p.chakuchiYoteiHms = complements.parseTime(p.chakuchiYoteiHms, false).substr(0, 5)
        } else {
          this.chakuchiYoteiHmsDisp = false
        }
        this.rec = Object.assign({}, p)
        resolve()
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // DB処理用フォーマット変換
    // ----------------------------------------------------------------------------------------------------
    convertToDBType: function () {
      const tmpData = Object.assign({}, this.rec)
      if (tmpData.tsumikomiSagyoJikan) {
        tmpData.tsumikomiSagyoJikan = filter.timeToMinFormatter(tmpData.tsumikomiSagyoJikan)
      }
      if (tmpData.torioroshiSagyoJikan) {
        tmpData.torioroshiSagyoJikan = filter.timeToMinFormatter(tmpData.torioroshiSagyoJikan)
      }
      if (tmpData.taikiJikan) {
        tmpData.taikiJikan = filter.timeToMinFormatter(tmpData.taikiJikan)
      }
      if (tmpData.warimashiTaishoJikan) {
        tmpData.warimashiTaishoJikan = filter.timeToMinFormatter(tmpData.warimashiTaishoJikan)
      }
      this.rec = Object.assign({}, tmpData)
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      const self = this
      // 基準日初期値設定
      self.baseYmd = date.getCurrentDate()
      const kihonJoho = self.kihonJohoList.length > 0 ? self.kihonJohoList[0] : null
      const eigyoshoInfo = self.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(self.currentKaishaCode, self.eigyoshoList, 'eigyoshoCd', self.usersEigyosho, self.baseYmd) : null
      self.shiharaiZumiMode = false
      self.registerMode = false
      self.deleteMode = false
      self.niukeninManualDisp = true
      self.hatsuchiManualDisp = true
      self.chakuchiManualDisp = true
      self.hinmeiManualDisp = true
      self.hatsuchiHmsDisp = true
      self.chakuchiHmsDisp = true
      self.hatsuchiYoteiHmsDisp = true
      self.chakuchiYoteiHmsDisp = true
      const initRec = {
        hacchusakiHikiukeYmd: self.baseYmd,
        hacchuEigyoshoId: eigyoshoInfo ? eigyoshoInfo.id : null,
        hacchusakiId: null,
        niukeninId: null,
        jishaKaishaNm: kihonJoho ? kihonJoho.kaishaSeishikiNm : '',
        jishaTelNo: kihonJoho ? kihonJoho.telNo : '',
        jishaFaxNo: kihonJoho ? kihonJoho.faxNo : '',
        jishaJusho: kihonJoho
          ? [kihonJoho.jusho1, kihonJoho.jusho2, kihonJoho.jusho3]
            .filter(part => part)// 空文字／null/undefined を除外
            .join('\n')// 改行コードで連結
          : '',
        jishaMailAddress: kihonJoho ? kihonJoho.eMail : '',
        hatsuchiId: null,
        chakuchiId: null,
        unsoHokenKanyuItakuFlg: true,
        mstHinmeiId: null,
        tsumikomiUmuFlg: false,
        torioroshiUmuFlg: false,
        sharyoId: null,
        jininId: null,
        hacchuYmd: self.baseYmd,
        shiharaiYoteiYmd: self.baseYmd,
        shiharaiZumiFlg: false,
        hacchusakiKbn: '1'
      }
      self.rec = Object.assign({}, initRec)
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
